<template>
    <div class="widget m-0 mb-2 py-2 px-1">
        <div class="row">
            <div class="col-2">
                <div
                    class="rounded-circle mr-2 icon d-flex justify-content-center align-items-center"
                >
                    <span class="text-white" style="font-stretch:extra-condensed;">SOAP</span>
                </div>
            </div>
            <div class="col-10">
                <small class="m-0">Export My Goals to SOAP NOTES</small>
                <div class="d-flex justify-content-start align-items-center">
                    <small style="white-space: nowrap">Select range:&nbsp</small>
                    <span>
                        <v-date-picker
                            popover-align="right"
                            mode="range"
                            v-model="interval"
                        ></v-date-picker>
                    </span>
                </div>
                <div class="mt-2">
                    <button
                        @click="saveData()"
                        class="btn btn-sm btn-primary font-weight-bold text-uppercase"
                    >
                        Save data
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "GoalsExportSoap",
    data() {
        return {
            interval: {
                start: new Date(),
                end: new Date(),
            },
        };
    },
    created() {
        this.interval.start.setDate(this.interval.start.getDate() - 7);
    },
    methods: {
        saveData() {},
    },
};
</script>

<style scoped lang="scss">
.widget {
    background-color: #fff;
    border: solid 1px #8f8f8f;
}
.icon {
    background-color: #348fc4;
    min-width: 3rem;
    max-width: 3rem;
    min-height: 3rem;
    max-height: 3rem;
}
</style>
<style lang="scss">
.popover-container {
    > input {
        font-size: 0.7rem;
        width: 100%;
    }
}
</style>
